// validates if a parameter is a number and returns that number, otherwise returns paramDefault

export default (el, paramSelector, valueIfMissing = false, valueIfEmpty = true) => {
	const param = el.getAttribute(paramSelector);

	if (!el.hasAttribute(paramSelector)) {
		return valueIfMissing;
	}

	if (param === '') {
		return valueIfEmpty;
	}

	return (param !== 'false' && !!param);
};
